var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scroller",
      staticClass: "virtual-scroller",
      style: _vm.scrollerStyle,
      on: { scroll: _vm.onScroll, wheel: _vm.onWheel },
    },
    [
      _c("div", {
        staticClass: "virtual-phantom",
        style: { height: _vm.totalHeight + "px" },
      }),
      _c(
        "div",
        {
          staticClass: "virtual-content",
          style: { transform: "translate3d(0, " + _vm.offsetY + "px, 0)" },
        },
        _vm._l(_vm.visibleRows, function (row) {
          return _c(
            "div",
            {
              key: row.rowIndex,
              ref: "rowElements",
              refInFor: true,
              staticClass: "virtual-row",
              style: {
                gridTemplateColumns: "repeat(" + _vm.cols + ", 1fr)",
                gap: _vm.gap + "px",
                marginBottom: _vm.gap + "px",
              },
              attrs: { "data-index": row.rowIndex },
            },
            _vm._l(row.items, function (item, idx) {
              return _c(
                "div",
                { key: _vm.getItemKey(item, idx), staticClass: "virtual-item" },
                [_vm._t("default", null, { item: item })],
                2
              )
            }),
            0
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }